export default function Privacy() {
  return (
    <div data-testid="privacy-page" className="bg-white">
      <section className="max-w-3xl mx-auto px-6 lg:px-8 py-24 sm:py-32">
        <div className="overline">Legal</div>
        <h1 className="font-serif text-5xl sm:text-6xl tracking-tight leading-[1.05] mt-6 text-[#0F172A]">
          Privacy Policy
        </h1>
        <p className="text-gray-500 mt-3 text-sm">Last updated: 12 June 2026</p>

        <div className="prose-editorial mt-12 space-y-6 text-[16px] leading-relaxed text-gray-700">
          <p>
            Sunsri Software Private Limited ("Sunsri", "we", "us") respects your privacy. This placeholder Privacy Policy describes what information we collect through this website and how we use it.
          </p>

          <h2 className="font-serif text-2xl text-[#0F172A] mt-10">1. Information we collect</h2>
          <p>
            When you submit our contact form, we collect the name, email, company, phone number, service interest, and message you provide. We may also collect anonymous analytics about how you use the site (pages visited, referrer, approximate location, device type).
          </p>

          <h2 className="font-serif text-2xl text-[#0F172A] mt-10">2. Cookies</h2>
          <p>
            We use a small number of first-party cookies and local-storage entries to remember your preferences (for example, your cookie consent choice). We do not sell or share these signals with third parties for advertising.
          </p>

          <h2 className="font-serif text-2xl text-[#0F172A] mt-10">3. How we use your information</h2>
          <p>
            We use the information you provide solely to respond to your enquiry, follow up on potential engagements, and improve our website. We do not sell or rent your personal data.
          </p>

          <h2 className="font-serif text-2xl text-[#0F172A] mt-10">4. Contact</h2>
          <p>
            For any privacy-related question or to request deletion of your data, write to{" "}
            <a className="underline" href="mailto:info@sunsrisoft.com">info@sunsrisoft.com</a>.
          </p>

          <p className="text-sm text-gray-500 italic mt-12">
            This is a placeholder document. The final policy will be drafted with legal counsel and posted at this URL.
          </p>
        </div>
      </section>
    </div>
  );
}
